import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComment = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_2630_9361)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.65815 1.93786C3.75533 0.711066 5.40199 0 7.56804 0C9.74703 0 11.3967 0.723136 12.4936 1.95357C13.5784 3.17041 14.05 4.80189 14.05 6.496C14.05 8.19031 13.5782 9.81582 12.492 11.0261C11.3952 12.2483 9.7477 12.9627 7.57409 12.964C6.81394 12.9765 6.05674 12.8764 5.32706 12.6675C4.41924 13.2331 3.36429 13.5248 2.28977 13.5029L0.788483 13.4722L1.77722 12.3421C2.14392 11.9229 2.40881 11.4265 2.55328 10.8916C1.55424 9.65132 1.03522 8.08735 1.10006 6.48813C1.10279 4.77644 1.5759 3.14798 2.65815 1.93786ZM3.70169 2.87115C2.90583 3.76102 2.50005 5.02816 2.50005 6.503V6.51798L2.49941 6.53296C2.44112 7.89368 2.91962 9.22284 3.83183 10.2341L4.06126 10.4885L4.0012 10.8258C3.93521 11.1963 3.82827 11.5566 3.68343 11.9004C4.08277 11.7701 4.46245 11.5789 4.8083 11.331L5.09953 11.1223L5.43914 11.2365C6.12089 11.4657 6.83682 11.5765 7.55594 11.5641L7.56199 11.564H7.56804C9.42346 11.564 10.6649 10.9661 11.4501 10.0911C12.2469 9.20318 12.65 7.94469 12.65 6.496C12.65 5.04711 12.2468 3.78059 11.4485 2.88518C10.6624 2.00336 9.42108 1.4 7.56804 1.4C5.72312 1.4 4.48577 1.99443 3.70169 2.87115Z",
				fill: "#1D4477"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2630_9361",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(0.399994)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgComment);
export default ForwardRef;
